'use client';

import { createFileRoute } from '@tanstack/react-router';
import GeneralStatusError from 'src/components/StatusError/General';

export const Route = createFileRoute('/_admin/401')({
	validateSearch: (search: Record<string, unknown>) => {
		return {
			occurredAt: (search.occurredAt as string) || undefined,
			method: (search.method as string) || undefined,
			uuid: (search.uuid as string) || undefined,
		};
	},
	component: UnauthorizedPage,
});

function UnauthorizedPage() {
	const { occurredAt, method, uuid } = Route.useSearch();

	return (
		<GeneralStatusError
			label="It looks like you don't have access to this page."
			occurredAt={occurredAt}
			method={method}
			uuid={uuid}
			action={{
				label: 'Go back to previous page',
				onClick: () => {
					window.history.back();
				},
			}}
		/>
	);
}
